import { Box, Skeleton } from '@mui/material';
import { FRAGMENT_CARD_PADDING_X } from '@app/modules/fragments/screens/list/fragment-card/constants';

/**
 * Skeleton placeholder matching CompositionCard layout: 16/9 media, title, footer meta + edits chip.
 */
export function CompositionCardSkeleton() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 1,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Skeleton variant="rectangular" sx={{ width: '100%', height: 'auto', aspectRatio: '16/9' }} />
      <Box sx={{ p: 1.5 }}>
        <Skeleton width="80%" height={24} />
      </Box>
      <Box
        sx={{
          px: FRAGMENT_CARD_PADDING_X,
          pb: 1.5,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          <Skeleton width={80} height={20} />
          <Skeleton width={60} height={20} />
        </Box>
        <Skeleton variant="rounded" width={72} height={24} sx={{ flexShrink: 0 }} />
      </Box>
    </Box>
  );
}
